let typingTimeOut;
const STOP_TYPING_TIMEOUT = 2000;

export default class NetJsService {
  static requireNetJs() {
    if (window.network === undefined) {
      // eslint-disable-next-line no-eval
      eval('require(["app"]);');
    }
  }

  static saveOperatorInfo(companyName, operatorLogin, operatorPassword, connectionId, chash, transactionIdCounter) {
    window.companyLogin = companyName;
    window.chash = chash;
    window.transactionIdCounter = transactionIdCounter;
    window.operatorLogin = operatorLogin;

    window.connectionId = connectionId;
    window.queryPostfix = `${chash}/${window.clientType}?connection-id=${connectionId}`;

    document.title = `${operatorLogin} - ${companyName} - ${document.title}`;

    window.onSessionRequired = () => {
      // console.warn('IN', window.connectionId, companyName, operatorLogin, operatorPassword, 'fin')
      window.operator_listener.onOperatorLogin(companyName, operatorLogin, operatorPassword);
    }
  }

  static sendMessage = (roomId, date, text) => {
    window.room_listener.onMessage(roomId, date || `${Date.now()}`, text);
  }

  static deleteMessage = (roomId, messageId) => {
    window.room_listener.onDeleteMessage(roomId, messageId);
  }

  static editMessage = ({ roomId, messageId, text }) => {
    window.room_listener.onEditMessage(roomId, messageId, text);
  }

  static operatorLogout = () => {
    // console.warn('OUT', window.connectionId)
    if (!window.operator_listener || !window.operator_listener.onOperatorLogout) return
    window.operator_listener.onOperatorLogout();
  }

  static changeTyping = roomId => {
    clearTimeout(typingTimeOut);

    if (window.room_listener && roomId !== '0') {
      window.room_listener.onTyping(roomId, '1');

      const stoppedTyping = () => { window.room_listener.onTyping(roomId, '0'); };
      typingTimeOut = setTimeout(stoppedTyping, STOP_TYPING_TIMEOUT);
    }
  }

  static getNetworkStatus() {
    return window.room_networkStatusHtml;
  }

  static isConnected() {
    return window.operator_listener !== undefined;
  }

  static onSessionRequired() {
    window.onSessionRequired();
  }

  static acceptCall(id) {
    window.operator_listener.onAcceptVisitorCall(id);
  }

  static closeRoom(id) {
    window.room_listener.onLeaveRoom(id);
  }

  static changeOperatorStatus(status) {
    window.operator_listener.onPresense(status);
  }

  static requestCannedResponseText(id, roomId) {
    window.operator_listener.onLoadCannedResponseText(id, roomId);
  }

  static sendTranscript(roomId, roomType, email) {
    window.room_listener.onEmailTranscript(roomId, email, roomType);
  }

  static callOperator(visitorId) {
    window.operator_listener.onPopup(visitorId);
  }

  static callAnotherOperator(sessionId) {
    window.operator_listener.onCallOperator(sessionId);
  }

  static changeMonitoringType(type) {
    window.vismon_listener.onVisitorMonitoring(type);
  }

  static inviteOperator(sessionId, roomId) {
    window.operator_listener.onInviteOperator(sessionId, roomId);
  }
}
